import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./NormalUIHelpers";

const DistributionNormalUIContext = createContext();

export function useDistributionNormalUIContext() {
  return useContext(DistributionNormalUIContext);
}

export const DistributionNormalUIConsumer =
  DistributionNormalUIContext.Consumer;

export function DistributionNormalUIProvider({
  distributionNormalUIEvents,
  children,
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initDistributionNormal = {
    name: "",
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initDistributionNormal,
    newDistributionNormalIndividuButtonClick:
      distributionNormalUIEvents.newDistributionNormalIndividuButtonClick,
    openEditDistributionNormalIndividualPage:
      distributionNormalUIEvents.openEditDistributionNormalIndividualPage,
    openEditDistributionNormalOrganizationPage:
      distributionNormalUIEvents.openEditDistributionNormalOrganizationPage,
    openDeleteDistributionNormalPage:
      distributionNormalUIEvents.openDeleteDistributionNormalPage,
    newDistributionNormalOrganizationButtonClick:
      distributionNormalUIEvents.newDistributionNormalOrganizationButtonClick,
  };

  return (
    <DistributionNormalUIContext.Provider value={value}>
      {children}
    </DistributionNormalUIContext.Provider>
  );
}
